import BaseResource                      from '@/lib/data/resource/BaseResource'
import { toNumberFormatNotationShort }   from '@/lib/utils/helper'
import { collect }                       from '@/lib/utils/array'
import NIISummaryAssetAggregateResource from '@/api/resources/risks/NIISummaryAssetAggregateResource'
import AssetCodeNameResource             from '@/api/resources/asset/AssetCodeNameResource'

export default class NIISummaryAssetResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Asset = payload.itemName ?? ''

    this.Historical = payload.historicalRisk ? toNumberFormatNotationShort(payload.historicalRisk) : ''
    this.HistoricalRaw = payload.historicalRisk ?? ''

    this.Simulation = payload.simulationRisk ? toNumberFormatNotationShort(payload.simulationRisk) : ''
    this.SimulationRaw = payload.simulationRisk ?? ''

    this.AnnualRisk = payload.annualRisk ? toNumberFormatNotationShort(payload.annualRisk) : ''
    this.AnnualRiskRaw = payload.annualRisk ?? ''

    this.ExtremeEvent = payload.eventsRisk ? toNumberFormatNotationShort(payload.eventsRisk) : ''
    this.ExtremeEventRaw = payload.eventsRisk ?? ''

    this.AggregateItem = payload?.aggregateItem || false
    this.PerCategoryCodes = payload?.perCategoryCodes || []
    this.PerCategoryItems = collect(payload?.perCategoryItems || [], NIISummaryAssetAggregateResource)

    this.PerCategoryNames = payload.perCategoryNames ?? []
    this.PerCategoryCodeNames = collect(payload?.perCategoryCodeNames || [], AssetCodeNameResource)

    this.Icon = this.AggregateItem ? 'mdi-plus-circle' : 'mdi-checkbox-blank-circle'
    this.IconExpanded = 'mdi-minus-circle-outline'
  }

  /* PROPERTIES */

  /* METHODS */
}
